export default {
	favorites: {
        list: [],
        error: '',
        loading: false,
        fetched: false,
        saving: false
    },
}